module.exports = __webpack_public_path__ + "img/esrc.9abc80b1.jpg";